import { Dispatch } from "react";
import axios from "axios";
import jwtAxios from "../../auth/jwtAxios";
import { fetchError } from "./Common";
import { getDisplayErrorMessage } from "../../utils/StringUtils";
import { RuleOfWeekResponse } from "../../types/models/RuleOfWeekResponse";
import { RuleOfWeekRequest } from "../../types/models/RuleOfWeekRequest";
import { AppActions } from "../../types";

export const getAdminRulesOfWeeks = (
  callBack: (ruleOfTheWeeks: RuleOfWeekResponse[] | undefined) => void
) => {
  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios
      .get("api/ruleOfTheWeek")
      .then((data) => {
        if (data.status === 200) {
          const rules: RuleOfWeekResponse[] = data.data;
          callBack(rules);
        } else {
          dispatch(fetchError("Something went wrong, Please try again! Status:" + data.status));
          callBack(undefined);
        }
      })
      .catch((error) => {
        if (axios.isAxiosError(error) || error instanceof Error)
          dispatch(fetchError(getDisplayErrorMessage(error)));
        callBack(undefined);
      });
  };
};

export const getAdminRuleOfWeek = (
  ruleOfTheWeekId: string,
  callBack: (ruleOfTheWeek: RuleOfWeekResponse | undefined) => void
) => {
  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios
      .get(`api/RuleOfTheWeek/${ruleOfTheWeekId}`)
      .then((data) => {
        if (data.status === 200) {
          const ruleOfTheWeek: RuleOfWeekResponse = data.data;
          callBack(ruleOfTheWeek);
        } else {
          dispatch(fetchError("Something went wrong, Please try again! Status:" + data.status));
          callBack(undefined);
        }
      })
      .catch((error) => {
        if (axios.isAxiosError(error) || error instanceof Error)
          dispatch(fetchError(getDisplayErrorMessage(error)));
        callBack(undefined);
      });
  };
};

export const createAdminRuleOfWeek = (
  request: RuleOfWeekRequest,
  callBack: (ruleOfTheWeek: RuleOfWeekResponse | undefined) => void
) => {
  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios
      .post("api/RuleOfTheWeek", request)
      .then((data) => {
        if (data.status === 201) {
          const ruleOfTheWeek: RuleOfWeekResponse = data.data;
          callBack(ruleOfTheWeek);
        } else {
          dispatch(fetchError("Something went wrong, Please try again! Status:" + data.status));
          callBack(undefined);
        }
      })
      .catch((error) => {
        if (axios.isAxiosError(error) || error instanceof Error)
          dispatch(fetchError(getDisplayErrorMessage(error)));
        callBack(undefined);
      });
  };
};

export const updateAdminRuleOfWeek = (
  ruleOfTheWeekId: string,
  request: RuleOfWeekRequest,
  callBack: (ruleOfTheWeek: RuleOfWeekResponse | undefined) => void
) => {
  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios
      .put(`api/RuleOfTheWeek/${ruleOfTheWeekId}`, request)
      .then((data) => {
        if (data.status === 200) {
          const ruleOfTheWeek: RuleOfWeekResponse = data.data;
          callBack(ruleOfTheWeek);
        } else {
          dispatch(fetchError("Something went wrong, Please try again! Status:" + data.status));
          callBack(undefined);
        }
      })
      .catch((error) => {
        if (axios.isAxiosError(error) || error instanceof Error)
          dispatch(fetchError(getDisplayErrorMessage(error)));
        callBack(undefined);
      });
  };
};

export const deleteAdminRuleOfWeek = (
  ruleOfTheWeekId: string,
  callBack: (result: boolean) => void
) => {
  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios
      .delete(`api/RuleOfTheWeek/${ruleOfTheWeekId}`)
      .then((data) => {
        if (data.status === 204) {
          callBack(true);
        } else {
          dispatch(fetchError("Something went wrong, Please try again! Status:" + data.status));
          callBack(false);
        }
      })
      .catch((error) => {
        if (axios.isAxiosError(error) || error instanceof Error)
          dispatch(fetchError(getDisplayErrorMessage(error)));
        callBack(false);
      });
  };
};
